import React from "react";

export const RacingAndSportsIcon = () => (
  <svg
    height="12"
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 226.3 119.87"
    data-qa-label="racingAndSportsIcon"
  >
    <path
      fill="#b1b235"
      d="M197.05,42.89c-.22-1.54-.66-2.64-1.54-3.74-.66-.88-1.54-1.76-2.64-2.2-1.98-1.1-4.4-1.54-7.26-1.54-3.08,0-5.5,.44-6.82,1.32s-2.2,1.98-2.2,3.74c0,1.54,.66,2.86,2.2,3.96s3.3,1.98,5.72,2.86c2.42,.88,5.06,1.54,7.92,2.2,2.86,.66,5.94,1.54,9.02,2.42s6.16,1.98,9.02,3.08c2.86,1.32,5.5,2.86,7.92,4.84,2.42,1.98,4.18,4.4,5.72,7.04,1.54,2.86,2.2,6.16,2.2,10.12,0,5.06-1.1,9.46-3.08,13.2-1.98,3.74-4.84,6.82-8.36,9.24-3.52,2.42-7.92,4.18-12.76,5.5-5.06,1.32-10.34,1.76-16.28,1.76s-10.78-.88-15.4-2.42c-4.62-1.54-8.58-3.74-11.88-6.38-3.3-2.64-5.94-5.72-7.7-9.24-1.98-3.52-2.86-7.26-3.08-11h27.05c.66,3.08,2.2,5.28,4.62,6.82,1.1,.66,2.42,1.32,3.74,1.54,1.54,.44,2.86,.44,4.18,.44,3.52,0,6.38-.44,8.58-1.54s3.08-2.64,3.08-4.84-1.32-3.74-3.74-5.06c-2.42-1.1-5.5-2.2-9.24-3.08-3.74-.88-7.7-1.98-12.1-3.08-4.4-1.1-8.36-2.64-12.1-4.62-3.74-1.98-6.82-4.62-9.24-8.14-2.42-3.3-3.74-7.7-3.74-13.42,0-4.62,.88-8.58,2.86-12.1s4.4-6.38,7.7-8.58c3.3-2.2,7.26-3.96,11.88-5.06s9.46-1.76,14.96-1.76c5.94,0,11.22,.66,15.62,2.2,4.4,1.54,8.14,3.3,11,5.94,3.08,2.42,5.28,5.28,7.04,8.8,1.76,3.3,2.86,6.82,3.3,10.56h-26.17v.22Z"
    />
    <g>
      <polygon
        fill="#b1b235"
        points="96.93 45.53 96.93 56.3 112.77 56.3 96.93 69.06 96.93 80.5 131.68 80.5 131.68 69.06 116.06 69.06 131.68 56.52 131.68 45.53 96.93 45.53"
      />
      <path
        fill="#b1b235"
        d="M96.93,86v18.25s.88,15.62,17.38,15.62,17.38-15.62,17.38-15.62v-18.25h-34.75Zm24.85,16.06s-.66,6.82-7.48,6.82-7.48-6.82-7.48-6.82v-4.62h14.96v4.62h0Z"
      />
      <path
        fill="#b1b235"
        d="M96.93,0V13.2l3.96,1.76v13.2l-3.96,1.98v12.32l34.75-14.52V15.62L96.93,0Zm12.76,24.41v-6.6l9.9,3.3-9.9,3.3Z"
      />
    </g>
    <path
      fill="#004693"
      d="M83.14,44.87c.44-18.69-18.91-24.19-27.71-24.19H13.64L0,106.23H23.53l5.28-31.23h7.48l13.2,31.23h26.17l-15.62-32.77s22.65-8.36,23.09-28.59Zm-28.37,10.34c-2.2,1.98-3.96,2.86-6.82,2.86H31.45l3.08-18.91h11.44c2.86,0,6.16-.66,8.8,1.1,2.42,1.54,3.52,4.62,3.52,7.26,0,3.3-1.32,5.94-3.52,7.7Z"
    />
  </svg>
);

const RacingAndSports = ({ width = "98px", height = "auto" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    version="1.1"
    id="Layer_1"
    x="0px"
    y="0px"
    viewBox="0 0 504.4 61.5"
    data-qa-label="racingAndSportsLogo"
  >
    <g>
      <path
        fill="#B1B235"
        d="M282.4,23.7c-0.1-0.7-0.3-1.2-0.7-1.7c-0.3-0.4-0.7-0.8-1.2-1c-0.9-0.5-2-0.7-3.3-0.7c-1.4,0-2.5,0.2-3.1,0.6   s-1,0.9-1,1.7c0,0.7,0.3,1.3,1,1.8c0.7,0.5,1.5,0.9,2.6,1.3c1.1,0.4,2.3,0.7,3.6,1c1.3,0.3,2.7,0.7,4.1,1.1   c1.4,0.4,2.8,0.9,4.1,1.4c1.3,0.6,2.5,1.3,3.6,2.2c1.1,0.9,1.9,2,2.6,3.2c0.7,1.3,1,2.8,1,4.6c0,2.3-0.5,4.3-1.4,6   c-0.9,1.7-2.2,3.1-3.8,4.2c-1.6,1.1-3.6,1.9-5.8,2.5c-2.3,0.6-4.7,0.8-7.4,0.8c-2.6,0-4.9-0.4-7-1.1c-2.1-0.7-3.9-1.7-5.4-2.9   c-1.5-1.2-2.7-2.6-3.5-4.2c-0.9-1.6-1.3-3.3-1.4-5h12.3c0.3,1.4,1,2.4,2.1,3.1c0.5,0.3,1.1,0.6,1.7,0.7c0.7,0.2,1.3,0.2,1.9,0.2   c1.6,0,2.9-0.2,3.9-0.7c1-0.5,1.4-1.2,1.4-2.2c0-1-0.6-1.7-1.7-2.3c-1.1-0.5-2.5-1-4.2-1.4c-1.7-0.4-3.5-0.9-5.5-1.4   c-2-0.5-3.8-1.2-5.5-2.1c-1.7-0.9-3.1-2.1-4.2-3.7c-1.1-1.5-1.7-3.5-1.7-6.1c0-2.1,0.4-3.9,1.3-5.5c0.9-1.6,2-2.9,3.5-3.9   c1.5-1,3.3-1.8,5.4-2.3c2.1-0.5,4.3-0.8,6.8-0.8c2.7,0,5.1,0.3,7.1,1c2,0.7,3.7,1.5,5,2.7c1.4,1.1,2.4,2.4,3.2,4   c0.8,1.5,1.3,3.1,1.5,4.8H282.4z"
      />
      <path
        fill="#B1B235"
        d="M300.7,51.6V12.3h18.9c5.6,0,9.8,1.2,12.6,3.6c2.8,2.4,4.1,5.6,4.1,9.7c0,2.1-0.3,4-1,5.7   c-0.6,1.7-1.6,3.2-3,4.4c-1.3,1.2-3,2.1-5.1,2.8c-2,0.6-4.5,1-7.3,1h-6.5v12.2H300.7z M318.9,30.2c1.5,0,2.8-0.3,3.7-1   c1-0.7,1.4-1.9,1.4-3.6c0-0.9-0.2-1.6-0.7-2.2c-0.5-0.5-1-1-1.7-1.3c-0.7-0.3-1.4-0.5-2.2-0.6c-0.8-0.1-1.5-0.1-2.2-0.1h-3.7v8.7   H318.9z"
      />
      <path
        fill="#B1B235"
        d="M359.7,11.2c3.5,0,6.5,0.6,9.1,1.7c2.6,1.2,4.7,2.7,6.4,4.6c1.7,1.9,3,4.1,3.8,6.5c0.8,2.5,1.3,5,1.3,7.6   c0,3.3-0.5,6.3-1.6,8.9c-1.1,2.6-2.5,4.8-4.4,6.6c-1.9,1.8-4,3.1-6.5,4c-2.5,0.9-5.2,1.4-8.1,1.4c-3.1,0-5.9-0.5-8.4-1.4   c-2.5-0.9-4.7-2.3-6.5-4.1c-1.8-1.8-3.2-4-4.2-6.6c-1-2.6-1.5-5.6-1.5-8.9c0-3.1,0.5-5.9,1.5-8.4c1-2.5,2.4-4.6,4.2-6.4   c1.8-1.8,4-3.2,6.5-4.1C353.8,11.7,356.6,11.2,359.7,11.2z M359.6,20.8c-1.5,0-2.7,0.3-3.7,1c-1,0.7-1.8,1.5-2.3,2.6   c-0.6,1-1,2.2-1.2,3.5c-0.2,1.3-0.4,2.6-0.4,3.8c0,1.3,0.1,2.6,0.3,3.9c0.2,1.3,0.6,2.5,1.2,3.6c0.6,1.1,1.4,2,2.4,2.7   c1,0.7,2.3,1.1,3.8,1.1c1.4,0,2.6-0.3,3.5-0.8c1-0.6,1.8-1.4,2.4-2.4c0.6-1,1.1-2.2,1.4-3.6c0.3-1.4,0.4-2.9,0.4-4.5   c0-1.3-0.1-2.7-0.4-4c-0.3-1.3-0.7-2.5-1.4-3.5c-0.6-1-1.4-1.9-2.4-2.5C362.2,21.1,361,20.8,359.6,20.8z"
      />
      <path
        fill="#B1B235"
        d="M398.6,37.9v13.7h-12.9V12.3h18.6c3.3,0,6,0.2,8.2,0.7c2.2,0.5,4,1.1,5.4,2c1.4,0.9,2.3,2.1,2.9,3.5   c0.6,1.4,0.9,3.1,0.9,5c0,2.3-0.5,4.3-1.6,6c-1.1,1.8-2.7,3-5,3.6c1,0.4,1.9,0.8,2.8,1.2c0.8,0.4,1.5,0.9,2.1,1.6   c0.6,0.7,1,1.7,1.3,2.9c0.3,1.2,0.5,2.8,0.5,4.7c0,1.3,0,2.3,0,3.2c0,0.9,0,1.6,0.1,2.1c0.1,0.5,0.2,0.9,0.4,1.2   c0.2,0.2,0.5,0.4,0.9,0.4v1.2h-13c-0.2-0.4-0.3-1.3-0.5-2.5c-0.1-1.2-0.2-2.7-0.2-4.4c0-1.3-0.1-2.3-0.2-3.2   c-0.1-0.9-0.5-1.6-1-2.1c-0.5-0.5-1.2-0.9-2.1-1.1c-0.9-0.2-2.1-0.4-3.6-0.4H398.6z M398.6,29.2h5.1c2,0,3.5-0.3,4.6-0.8   c1-0.5,1.6-1.5,1.6-2.9c0-1.4-0.5-2.4-1.4-3.1c-1-0.7-2.2-1-3.7-1h-6V29.2z"
      />
      <path
        fill="#B1B235"
        d="M425.6,12.3h36v10.3h-11.6v29h-12.9v-29h-11.6V12.3z"
      />
      <path
        fill="#B1B235"
        d="M487.6,23.7c-0.1-0.7-0.3-1.2-0.7-1.7c-0.3-0.4-0.7-0.8-1.2-1c-0.9-0.5-2-0.7-3.3-0.7c-1.4,0-2.5,0.2-3.1,0.6   c-0.7,0.4-1,0.9-1,1.7c0,0.7,0.3,1.3,1,1.8c0.7,0.5,1.5,0.9,2.6,1.3c1.1,0.4,2.3,0.7,3.6,1c1.3,0.3,2.7,0.7,4.1,1.1   c1.4,0.4,2.8,0.9,4.1,1.4c1.3,0.6,2.5,1.3,3.6,2.2c1.1,0.9,1.9,2,2.6,3.2c0.7,1.3,1,2.8,1,4.6c0,2.3-0.5,4.3-1.4,6   c-0.9,1.7-2.2,3.1-3.8,4.2c-1.6,1.1-3.6,1.9-5.8,2.5c-2.3,0.6-4.7,0.8-7.4,0.8c-2.6,0-4.9-0.4-7-1.1c-2.1-0.7-3.9-1.7-5.4-2.9   s-2.7-2.6-3.5-4.2c-0.9-1.6-1.3-3.3-1.4-5h12.3c0.3,1.4,1,2.4,2.1,3.1c0.5,0.3,1.1,0.6,1.7,0.7c0.7,0.2,1.3,0.2,1.9,0.2   c1.6,0,2.9-0.2,3.9-0.7c1-0.5,1.4-1.2,1.4-2.2c0-1-0.6-1.7-1.7-2.3c-1.1-0.5-2.5-1-4.2-1.4c-1.7-0.4-3.5-0.9-5.5-1.4   c-2-0.5-3.8-1.2-5.5-2.1c-1.7-0.9-3.1-2.1-4.2-3.7c-1.1-1.5-1.7-3.5-1.7-6.1c0-2.1,0.4-3.9,1.3-5.5c0.9-1.6,2-2.9,3.5-3.9   c1.5-1,3.3-1.8,5.4-2.3c2.1-0.5,4.3-0.8,6.8-0.8c2.7,0,5.1,0.3,7.1,1c2,0.7,3.7,1.5,5,2.7c1.4,1.1,2.4,2.4,3.2,4   c0.8,1.5,1.3,3.1,1.5,4.8H487.6z"
      />
      <polygon
        fill="#B1B235"
        points="237.9,24.9 237.9,29.8 245.1,29.8 237.9,35.6 237.9,40.8 253.7,40.8 253.7,35.6 246.6,35.6    253.7,29.9 253.7,24.9  "
      />
      <path
        fill="#B1B235"
        d="M237.9,43.3v8.3c0,0,0.4,7.1,7.9,7.1c7.5,0,7.9-7.1,7.9-7.1v-8.3H237.9z M249.2,50.6c0,0-0.3,3.1-3.4,3.1   c-3.1,0-3.4-3.1-3.4-3.1v-2.1h6.8V50.6z"
      />
      <path
        fill="#B1B235"
        d="M237.9,4.2v6l1.8,0.8V17l-1.8,0.9v5.6l15.8-6.6v-5.6L237.9,4.2z M243.7,15.3v-3l4.5,1.5L243.7,15.3z"
      />
      <path
        fill="#184890"
        d="M44.6,24.6C44.8,16.1,36,13.6,32,13.6s-19,0-19,0L6.8,52.5h10.7l2.4-14.2h3.4l6,14.2h11.9l-7.1-14.9   C34.1,37.6,44.4,33.8,44.6,24.6z M31.7,29.3c-1,0.9-1.8,1.3-3.1,1.3c-1,0-1.9,0-2.9,0c-0.3,0-4.6,0-4.6,0l1.4-8.6c0,0,3.5,0,5.2,0   c1.3,0,2.8-0.3,4,0.5c1.1,0.7,1.6,2.1,1.6,3.3C33.3,27.3,32.7,28.5,31.7,29.3z"
      />
      <path
        fill="#184890"
        d="M65.4,13.6L42.9,52.5h11.6l3.4-6h16.2l1.3,6h11.7L76.8,13.6H65.4z M62.4,38.2c0,0,5.3-9.7,6.9-12.6   c0,0,2.1,8.1,3,12.5l0,0.1L62.4,38.2z"
      />
      <path
        fill="#184890"
        d="M112,22.4c5.8,0.1,9,2.9,9,2.9l6.2-7.6c0,0-5.5-7.1-19.3-5c-7,1.1-18.7,8.2-18.8,21.8   c-0.1,12.7,9.5,19,20.2,19c9.3,0,15.6-5.9,15.6-5.9l-4.6-8.1c0,0-4.3,3.5-9.3,3.8c-7.1,0.5-10.7-4.5-10.6-9.2   C100.5,24.4,109.6,22.4,112,22.4z"
      />
      <path
        fill="#184890"
        d="M128.7,52.6h10.7l6.2-39c0,0-11.2,0-11,0L128.7,52.6z"
      />
      <path
        fill="#184890"
        d="M176.5,34.7l-12.6-21.1c0,0-11.2,0-11,0l-5.9,39h10.7l3.4-21.4l12.7,21.4h10.7l6.2-39c0,0-11.2,0-11,0   L176.5,34.7z"
      />
      <path
        fill="#184890"
        d="M213.2,29.9l-1.1,7h8.8l-0.9,4.8c-1.7,0.8-3.8,1.6-6,1.8c-7.1,0.5-10.7-4.5-10.6-9.2   c0.2-9.8,9.3-11.8,11.6-11.8c5.8,0.1,9,2.9,9,2.9l6.2-7.6c0,0-5.5-7.1-19.3-5c-7,1.1-18.7,8.2-18.8,21.8c-0.1,12.7,9.5,19,20.2,19   c9.3,0,13.9-4.7,14.8-5.4c1.4-1.1,2.3-2.8,2.3-2.8l2.1-15.6H213.2z"
      />
    </g>
  </svg>
);

export default RacingAndSports;
